export enum ReviewsState {
  Initial = 'initial',
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Withdrawn = 'withdrawn',
  PendingWithdrawal = 'pendingWithdrawal',
  WithdrawalRejected = 'withdrawalRejected',
}
